import {OpenTraderHelpDialogService} from "./service/OpenTraderHelpService";
import {openTraderVideos, OpenTraderVideos} from "./service/components/OpenTraderVideosComponent";
import {wistiaEmbedVideo, WistiaEmbedVideo} from "./service/components/WistiaEmbedVideoComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.help`;

    return angular.module(moduleName, [])
                  .service(OpenTraderHelpDialogService.id, OpenTraderHelpDialogService)
                  .component(OpenTraderVideos, openTraderVideos())
                  .component(WistiaEmbedVideo, wistiaEmbedVideo())
                  .name;
}
